<template>
  <div>
    <div class="row border-bottom border-secondary mb-3">
      <Aguarde :show="httpSend"></Aguarde>
      <div class="col-12">
        <b-form @submit.prevent="getRanfs()">
          <div class="row">
            <div class="col-md-3">
              <b-form-group label="Ano Emissão da Nota" label-for="not_emissao_ano">
                <input
                    id="not_emissao_ano"
                    v-model="filtro.not_emissao_ano"
                    v-mask="'####'"
                    type="text"
                    maxlength="4"
                    class="form-control"
                    placeholder="Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Número da Nota"
                  label-for="fnot_numero">
                <input
                    id="fnot_numero"
                    v-model="filtro.not_numero"
                    type="text"
                    maxlength="11"
                    class="form-control"
                    placeholder="Número completo">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Competência Inicial"
                  label-for="sep_competencia_inicial">
                <input
                    id="sep_competencia_inicial"
                    v-model="filtro.sep_competencia_inicial"
                    v-mask="'##/####'"
                    type="text"
                    maxlength="7"
                    class="form-control"
                    placeholder="Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Competência Final"
                  label-for="sep_competencia_final">
                <input
                    id="sep_competencia_final"
                    v-model="filtro.sep_competencia_final"
                    v-mask="'##/####'"
                    type="text"
                    maxlength="7"
                    class="form-control"
                    placeholder="Mês/Ano">
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <b-form-group
                  label="Emissão da Nota - Incial"
                  label-for="not_emissao_incial">
                <input
                    id="not_emissao_incial"
                    v-model="filtro.not_emissao_incial"
                    v-mask="'##/##/####'"
                    type="text"
                    maxlength="10"
                    class="form-control"
                    placeholder="Dia/Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="Emissão da Nota - Final"
                  label-for="not_emissao_final">
                <input
                    id="not_emissao_final"
                    v-mask="'##/##/####'"
                    v-model="filtro.not_emissao_final"
                    type="text"
                    maxlength="10"
                    class="form-control"
                    placeholder="Dia/Mês/Ano">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Situação" label-for="not_cancelada">
                <select id="not_cancelada"
                        @change="getRanfs()"
                        v-model="filtro.not_cancelada"
                        class="custom-select" type="text">
                  <option value="0">Todos</option>
                  <option value="1">Emitida</option>
                  <option value="2">Cancelada</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="ISS Retido" label-for="sep_iss_retido">
                <select id="sep_iss_retido"
                        @change="getRanfs()"
                        v-model="filtro.sep_iss_retido"
                        class="custom-select" type="text">
                  <option value="0">Todos</option>
                  <option value="S">Sim</option>
                  <option value="N">Não</option>
                </select>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                  label="Nome/Razão do Prestador"
                  label-for="fsep_razao_social_tomador">
                <input
                    id="fsep_razao_social_tomador"
                    v-model="filtro.sep_razao_social_tomador"
                    type="text"
                    maxlength="20"
                    class="form-control"
                    placeholder=" ">
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group
                  label="CPF/CNPJ do Prestador">
                <the-mask class="form-control" v-model="filtro.sep_cpf_cnpj_tomador"
                          :mask="['###.###.###-##', '##.###.###/####-##']"/>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Notas por Página" label-for="nota_pagina">
                <select id="nota_pagina"
                        @change="getRanfs()"
                        v-model="filtro.nota_pagina"
                        class="custom-select" type="text">
                  <option value="10">10/Pág.</option>
                  <option value="30">30/Pág.</option>
                  <option value="50">50/Pág.</option>
                  <option value="80">80/Pág.</option>
                  <option value="100">100/Pág.</option>
                  <option value="">Sem Limite</option>
                </select>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group
                  label="'"
                  class="text-white">
                <button type="submit"
                        class="btn btn-label btn-block btn-primary"><i
                    class="bx bx-search label-icon"></i>
                  Pesquisar
                </button>
              </b-form-group>
            </div>
          </div>
        </b-form>
      </div>
    </div>
    <div v-show="!list_ranfs || list_ranfs.length < 1" role="alert" aria-live="polite"
         aria-atomic="true" class="alert alert-primary text-center">
      Sem Ranfs
    </div>

    <div v-for="g in list_ranfs" :key="g.ran_codigo" class="row">
      <div class="col-md-12 mb-3 border-bottom border-secondary">
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="Código do Ranfs">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold">{{ g.ran_codigo.padStart(10, "0") }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group label="Emissão do Ranfs">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold">{{ g.ran_emissao | formatDateHora }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Situação">
              <h6 class="mb-0">
                <span v-show="g.ran_data_cancelamento" class="badge badge-danger font-size-12">Cancelada</span>
                <span v-show="!g.ran_data_cancelamento"
                      class="badge badge-success font-size-12">Emitida</span>
              </h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="Nota Fiscal">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold">{{ g.ran_numero }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group label="Emissão da Nota - Competência">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold">{{ g.ran_nota_emissao | formatDate }} - </span>
                <span class="text-body font-weight-bold">{{ g.sep_competencia | formatDateCompetencia }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Valor do ISS">
              <h6 class="mb-0">{{ g.sep_iss | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="CPF/CNPJ Prestador">
              <h6 class="mb-0">
                <span v-if="g.sep_cpf_cnpj_prestador.length < 12">{{
                    g.sep_cpf_cnpj_prestador | VMask('###.###.###-##')
                  }}</span>
                <span v-else>{{ g.sep_cpf_cnpj_prestador| VMask('##.###.###/####-##') }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group label="Nome/Razao Social Prestador">
              <h6 class="mb-0">{{ g.sep_razao_social_prestador }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Valor da Nota">
              <h6 class="mb-0">{{ g.sep_valor | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button type="button" @click="visualiza_ranfs(g)" class="btn btn-dark btn-sm mb-2 mr-2">
              <i class="mdi mdi-file-pdf-outline"></i> Visualizar Ranfs
            </button>
            <button type="button" @click="baixar_ranfs(g)" class="btn btn-secondary btn-sm mb-2 mr-2">
              <i class="mdi mdi-file-pdf-outline"></i> Baixar Ranfs
            </button>
            <button v-if="!g.ran_data_cancelamento" type="button" @click="showModalRanfCancelamento(g)"
                    class="btn btn-outline-danger btn-sm mb-2 mr-2">
              <i class="mdi mdi-cancel"></i> Cancelar Ranfs
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-show="list_ranfs && list_ranfs.length > 0" class="row">
      <div class="col-lg-12">
        <paginate
            :page-count="total_paginas"
            :page-range="3"
            :margin-pages="3"
            :click-handler="proximaPagina"
            :prev-text="'Página anterior'"
            :next-text="'Próxima página'"
            :prev-link-class="'page-link'"
            :next-link-class="'page-link'"
            :page-link-class="'page-link'"
            :container-class="'pagination pagination-rounded justify-content-center mt-4'"
            :page-class="'page-item'">
        </paginate>
      </div>
    </div>

    <modal :height="'auto'" :clickToClose="false" :adaptive="true" :draggable="true" name="modal-ranfs-cancelamento">
      <div v-if="ranfs.ran_codigo" class="card mb-0">
        <div class="card-body">
          <div class="row">
            <div class="col-md-8">
              <h5 class="mt-1 mb-4">Cancelar Ranfs</h5>
            </div>
            <div class="col-md-4 text-right">
              <button type="button" @click="hideModalRanf()" title="Fechar"
                      class="btn btn-outline-dark btn-sm mr-2 mt-0"><i class="bx bx-x"></i> Fechar
              </button>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4">
                <b-form-group label="Nota Fiscal">
                  <h6 class="mb-0">{{ ranfs.ran_numero }}</h6>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Emissão da Nota - Competência">
                  <h6 class="mb-0">
                    <span>{{ ranfs.ran_nota_emissao | formatDate }} - </span>
                    <span>{{ ranfs.sep_competencia | formatDateCompetencia }}</span>
                  </h6>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <b-form-group label="CPF/CNPJ Prestador">
                  <h6 class="mb-0">
                <span v-if="ranfs.sep_cpf_cnpj_prestador.length < 12">{{
                    ranfs.sep_cpf_cnpj_prestador | VMask('###.###.###-##')
                  }}</span>
                    <span v-else>{{ ranfs.sep_cpf_cnpj_prestador| VMask('##.###.###/####-##') }}</span>
                  </h6>
                </b-form-group>
              </div>
              <div class="col-md-8">
                <b-form-group label="Nome/Razao Social Prestador">
                  <h6 class="mb-0">{{ ranfs.sep_razao_social_prestador }}</h6>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-form-group label="Motivo do Cancelamento">
                  <textarea
                      class="form-control"
                      v-model="ranfs.ran_descricao_cancelamento"
                      :maxlength="255"
                      rows="2"
                      placeholder="Informe o motivo do cancelamento. Máximo de 255 caracteres"
                  ></textarea>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-right">
                <b-form-group
                    label-class="text-white"
                    label="´">
                  <button type="button" title="Cancelar Ranfs"
                          @click="showModalRanfCancelamentoConfirmacao()"
                          class="btn btn-danger btn-sm mr-2 mt-1">
                    <i class="bx bx-check-double"></i> Cancelar Ranfs
                  </button>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal :height="'auto'" :clickToClose="false" :adaptive="true" name="modal-ranfs-cancelamento-confirmacao">
      <div class="card mb-0">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 text-center">
              <h5 class="mt-1 mb-4">Confirma o cancelamento do Ranfs?</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 text-right">
              <button type="button" @click="cancelaRanfs()"
                      class="btn btn-success mr-3 mt-1">
                <i class="bx bx-check-double"></i> SIM
              </button>
            </div>
            <div class="col-md-6 text-left">
              <button type="button" @click="hideModalRanfCancelamentoConfirmacao()"
                      class="btn btn-dark ml-3 mt-1">
                <i class="bx bx-check-double"></i> NÂO
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>

  </div>
</template>
<script>
import Paginate from 'vuejs-paginate'
import {TheMask} from 'vue-the-mask'
import Aguarde from "@/components/widgets/aguarde";
import {impressao} from "@/helps/impressao";
import {isMobile} from "@/helps/util"
import {cancelarRanfs, downloadRanfs, listRanfs} from "@/api/ranfs/ranfs";
import {setRelRanfs} from "@/api/relatorio/ranfs";
import {notifyAviso, notifyErro, notifySucesso} from "@/helps/notificacao";

export default {
  components: {
    Aguarde,
    TheMask,
    Paginate
  },
  data() {
    return {
      list_ranfs: [],
      httpSend: false,
      filtro: {
        eco_codigo: null,
        pagina: 1,
        nota_pagina: "10",
        not_emissao_ano: "",
        not_numero: "",
        sep_competencia_inicial: "",
        sep_competencia_final: "",
        not_emissao_incial: "",
        not_emissao_final: "",
        not_numero_inicial: "",
        not_numero_final: "",
        sep_exigibilidade_iss: "0",
        not_cancelada: "0",
        sep_iss_retido: "0",
        sep_cpf_cnpj_tomador: "",
        sep_razao_social_tomador: "",
      },
      total_paginas: 0,
      ranfs: {},
    };
  },
  created() {
    if (this.empresa) {
      this.filtro.eco_codigo = this.empresa.eco_codigo;
      this.getRanfs();
    }
  },
  computed: {
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
  },
  methods: {
    proximaPagina(pageNum) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.filtro.pagina = pageNum;
      this.getRanfs()
    },
    getRanfs() {
      this.httpSend = true;
      listRanfs(this.empresa.eco_codigo, this.filtro).then(result => {
        this.total_paginas = result.dados.paginas;
        this.list_ranfs = result.dados.ranfs;
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    visualiza_ranfs(ranfs) {
      this.httpSend = true;
      if (isMobile()) {
        impressao(setRelRanfs(ranfs.ran_hash), 'P').catch(error => {
          console.log(error)
        }).finally(() => {
          this.httpSend = false;
        })
      } else {
        this.$router.push({name: 'contribuinte-ranfs-visualizar', params: {ran_hash: ranfs.ran_hash}})
      }
    },
    baixar_ranfs(ranfs) {
      this.httpSend = true;
      downloadRanfs(ranfs.ran_hash).then(result => {
        if (result.status) {
          window.open(result.mensagem, '_blank');
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    showModalRanfCancelamento(ranfs) {
      this.ranfs = ranfs;
      this.$modal.show('modal-ranfs-cancelamento');
    },
    showModalRanfCancelamentoConfirmacao() {
      if (!this.ranfs.ran_descricao_cancelamento || this.ranfs.ran_descricao_cancelamento.length < 1) {
        notifyAviso("Atenção", "Informe o motivo do cancelamento")
        return
      }
      this.$modal.show('modal-ranfs-cancelamento-confirmacao');
    },
    hideModalRanf() {
      this.$modal.hide('modal-ranfs-cancelamento');
      this.ranfs = {};
    },
    hideModalRanfCancelamentoConfirmacao() {
      this.$modal.hide('modal-ranfs-cancelamento-confirmacao');
    },
    cancelaRanfs() {
      this.httpSend = true;
      const dados = {
        ran_codigo: this.ranfs.ran_codigo,
        ran_descricao_cancelamento: this.ranfs.ran_descricao_cancelamento
      }
      cancelarRanfs(dados).then(result => {
        if (result.status) {
          this.getRanfs();
          notifySucesso('Ranfs', result.mensagem)
          this.hideModalRanfCancelamentoConfirmacao();
          this.hideModalRanf();
        } else {
          notifyErro('Erro', result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    }
  }
}
</script>

